import React, { useEffect } from 'react'
import { useGetAllExperienceTypesQuery } from '../api/experienceTypeApiSlice'
import SelectExperienceTypePresentation from '../select.exp.type.presentation/SelectExperienceTypePresentation'
import { type ExperienceType } from '../types/types'
interface SelectExperienceTypeContainerProps {
  onSelectHanlder: (exptype: Partial<ExperienceType> | null) => void
  experienceType?: Partial<ExperienceType> | null
}
const SelectExperienceTypeContainer: React.FC<
SelectExperienceTypeContainerProps
> = ({ onSelectHanlder, experienceType }) => {
  const {
    data: exptypes,
    
    isSuccess,
  } = useGetAllExperienceTypesQuery();

  const onSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onSelectHanlder(exptypes?.entities[e.target.value] ?? null)
  }

  useEffect(() => {
    if (exptypes && !experienceType) {
      const value = exptypes?.entities ? Object.values(exptypes.entities) : []
      const gradegy = value.find((exptype): exptype is ExperienceType => exptype !== undefined && exptype.title === 'Gradegy')
      if (gradegy?._id) {
        onSelectHanlder(exptypes?.entities[gradegy?._id] ?? null)
      }
    }
  }
  , [exptypes, experienceType])

  return (
    <>
      {isSuccess && (
        <SelectExperienceTypePresentation
          exptypes={exptypes}
          onSelected={onSelected}
          defaultExperienceType={experienceType}
        />
      )}
    </>
  )
}

export default SelectExperienceTypeContainer
